import { render, staticRenderFns } from "./customerData.vue?vue&type=template&id=13ae0fab&scoped=true&"
import script from "./customerData.vue?vue&type=script&lang=js&"
export * from "./customerData.vue?vue&type=script&lang=js&"
import style0 from "./customerData.vue?vue&type=style&index=0&id=13ae0fab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae0fab",
  null
  
)

component.options.__file = "customerData.vue"
export default component.exports